<template>
  <dialog :class="['modal', { 'modal-open': open }]">
    <div class="modal-box w-11/12 max-w-4xl">
      <form method="dialog">
        <button
          class="btn btn-sm btn-circle btn-ghost absolute top-2 right-2"
          @click="$emit('update:open', false)"
        >
          ✕
        </button>
      </form>

      <h3 class="mb-4 text-lg font-bold">
        <i class="fa-solid fa-bolt text-warning mr-2"></i>
        Cấu hình Dò Pass
      </h3>

      <div class="space-y-6">
        <!-- Scan Option Tabs -->
        <div role="tablist" class="tabs tabs-lifted tabs-lg">
          <a
            role="tab"
            class="tab"
            :class="{ 'tab-active': scanOption === 'single' }"
            @click="scanOption = 'single'"
          >
            <i class="fa-solid fa-desktop mr-2"></i> 1 IP
          </a>
          <a
            role="tab"
            class="tab"
            :class="{ 'tab-active': scanOption === 'range' }"
            @click="scanOption = 'range'"
          >
            <i class="fa-solid fa-network-wired mr-2"></i> Dải IP
          </a>
          <a
            role="tab"
            class="tab"
            :class="{ 'tab-active': scanOption === 'auto' }"
            @click="scanOption = 'auto'"
          >
            <i class="fa-solid fa-robot mr-2"></i> Tự động
          </a>
        </div>

        <div class="bg-base-100 border-base-300 rounded-box -mt-1 p-6">
          <!-- IP Input Section -->
          <div class="form-control mb-6 w-full">
            <h4 class="mb-2 flex items-center font-semibold">
              <i
                class="fa-solid mr-2"
                :class="scanOption === 'auto' ? 'fa-robot' : 'fa-ethernet'"
              ></i>
              {{
                scanOption === "single"
                  ? "Địa chỉ IP"
                  : scanOption === "range"
                    ? "Dải IP (CIDR)"
                    : "Tự động quét"
              }}
            </h4>

            <div v-if="scanOption !== 'auto'" class="flex w-full flex-col">
              <div class="flex h-12 w-full items-center">
                <input
                  type="text"
                  class="input input-bordered h-full w-full"
                  :class="{ 'input-error': ipError }"
                  :placeholder="
                    scanOption === 'single' ? '192.168.1.10' : '192.168.1.0/24'
                  "
                  v-model="ipInput"
                />
              </div>
              <span v-if="ipError" class="text-error mt-1 px-1 text-sm">
                {{ ipError }}
              </span>
            </div>
            <div
              v-else
              class="alert alert-info flex h-12 min-h-0 items-center p-0 px-4"
            >
              <i class="fa-solid fa-circle-info mr-2"></i>
              <span class="truncate"
                >Hệ thống sẽ tự động lấy IP hiện tại của Agent và quét các thiết
                bị trong cùng mạng LAN.</span
              >
            </div>

            <label class="label">
              <span
                class="label-text-alt text-base-content/60"
                :class="{ 'opacity-0': scanOption === 'auto' }"
              >
                {{
                  scanOption === "single"
                    ? "Nhập chính xác 1 địa chỉ IP đích"
                    : scanOption === "range"
                      ? "Nhập dải IP theo định dạng CIDR (VD: 192.168.1.0/24)"
                      : "Placeholder Text for Auto Option Layout Stability"
                }}
              </span>
            </label>
          </div>

          <div class="divider"></div>

          <!-- Credentials Section -->
          <div class="grid grid-cols-1 gap-8 md:grid-cols-2">
            <!-- User Section -->
            <div class="form-control">
              <h4 class="mb-2 flex items-center font-semibold">
                <i class="fa-solid fa-user mr-2"></i> Username
              </h4>

              <div class="tabs tabs-boxed mb-2">
                <a
                  class="tab"
                  :class="{ 'tab-active': userStats.type === 'manual' }"
                  @click="userStats.type = 'manual'"
                  >Nhập tay</a
                >
                <a
                  class="tab"
                  :class="{ 'tab-active': userStats.type === 'file' }"
                  @click="userStats.type = 'file'"
                >
                  File
                </a>
              </div>

              <div v-if="userStats.type === 'manual'">
                <input
                  type="text"
                  class="input input-bordered w-full"
                  placeholder="admin"
                  v-model="userStats.manual"
                />
              </div>
              <div v-else>
                <input
                  type="file"
                  class="file-input file-input-bordered w-full"
                  accept=".txt"
                  @change="handleUserFile"
                />
                <div
                  v-if="userStats.file"
                  class="text-success mt-2 flex items-center text-xs"
                >
                  <i class="fa-solid fa-check-circle mr-1"></i>
                  Đã chọn: {{ userStats.fileName }} ({{ userStats.count }} dòng)
                </div>
              </div>
            </div>

            <!-- Password Section -->
            <div class="form-control">
              <h4 class="mb-2 flex items-center font-semibold">
                <i class="fa-solid fa-key mr-2"></i> Password
              </h4>

              <div class="tabs tabs-boxed mb-2">
                <a
                  class="tab"
                  :class="{ 'tab-active': passStats.type === 'manual' }"
                  @click="passStats.type = 'manual'"
                >
                  Nhập tay
                </a>
                <a
                  class="tab"
                  :class="{ 'tab-active': passStats.type === 'file' }"
                  @click="passStats.type = 'file'"
                >
                  File
                </a>
              </div>

              <div v-if="passStats.type === 'manual'">
                <input
                  type="text"
                  class="input input-bordered w-full"
                  placeholder="123456"
                  v-model="passStats.manual"
                />
              </div>
              <div v-else>
                <input
                  type="file"
                  class="file-input file-input-bordered w-full"
                  accept=".txt"
                  @change="handlePassFile"
                />
                <div
                  v-if="passStats.file"
                  class="text-success mt-2 flex items-center text-xs"
                >
                  <i class="fa-solid fa-check-circle mr-1"></i>
                  Đã chọn: {{ passStats.fileName }} ({{ passStats.count }} dòng)
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-action">
        <button class="btn" @click="$emit('update:open', false)">Hủy bỏ</button>
        <button
          class="btn btn-primary"
          :disabled="!isValid"
          @click="handleStart"
        >
          <i class="fa-solid fa-play mr-1"></i>
          Bắt đầu quét
        </button>
      </div>
    </div>
  </dialog>
</template>

<script setup lang="ts">
import { axios_instance } from "@/api/api";
import { useField } from "vee-validate";
import { computed, reactive, ref } from "vue";
import { useRoute } from "vue-router";
import { toast } from "vue3-toastify";

defineProps<{
  open: boolean;
}>();

const emit = defineEmits<{
  "update:open": [value: boolean];
  scanned: [data: unknown];
}>();

const route = useRoute();

const scanOption = ref<"single" | "range" | "auto">("single");

const ipRules = computed(() => {
  if (scanOption.value === "single") return "required|isIP";
  if (scanOption.value === "range") return "required|isCIDR";
  return "";
});

const {
  value: ipInput,
  errorMessage: ipError,
  meta: ipMeta,
} = useField<string>("ip", ipRules, {
  initialValue: "",
  label: "Địa chỉ IP",
});

// User Input State
const userStats = reactive({
  type: "manual" as "manual" | "file",
  manual: "",
  file: null as File | null,
  fileName: "",
  count: 0,
});

// Password Input State
const passStats = reactive({
  type: "manual" as "manual" | "file",
  manual: "",
  file: null as File | null,
  fileName: "",
  count: 0,
});

const handleUserFile = (event: Event) => {
  const target = event.target as HTMLInputElement;
  const file = target.files?.[0];
  if (file) {
    userStats.file = file;
    userStats.fileName = file.name;
    // Count lines just for display
    const reader = new FileReader();
    reader.onload = (e) => {
      const text = e.target?.result as string;
      userStats.count = text.split("\n").filter((l) => l.trim()).length;
    };
    reader.readAsText(file);
  } else {
    userStats.file = null;
    userStats.fileName = "";
    userStats.count = 0;
  }
};

const handlePassFile = (event: Event) => {
  const target = event.target as HTMLInputElement;
  const file = target.files?.[0];
  if (file) {
    passStats.file = file;
    passStats.fileName = file.name;
    // Count lines just for display
    const reader = new FileReader();
    reader.onload = (e) => {
      const text = e.target?.result as string;
      passStats.count = text.split("\n").filter((l) => l.trim()).length;
    };
    reader.readAsText(file);
  } else {
    passStats.file = null;
    passStats.fileName = "";
    passStats.count = 0;
  }
};

const isValid = computed(() => {
  const isIpValid = scanOption.value === "auto" || ipMeta.valid;
  const isUserValid =
    (userStats.type === "manual" && userStats.manual.trim().length > 0) ||
    (userStats.type === "file" && userStats.file);
  const isPassValid =
    (passStats.type === "manual" && passStats.manual.trim().length > 0) ||
    (passStats.type === "file" && passStats.file);

  return isIpValid && isUserValid && isPassValid;
});

const handleStart = async () => {
  try {
    const formData = new FormData();
    const agent_id = route.params.client_id as string;
    if (!agent_id) {
      toast.error("Không tìm thấy thông tin Agent");
      return;
    }
    formData.append("agent_id", agent_id);
    formData.append("option", "ip");

    // Handle IP
    if (scanOption.value === "auto") {
      formData.append("ip", "auto-detect");
    } else {
      formData.append("ip", ipInput.value.trim());
    }

    // Handle User
    if (userStats.type === "manual") {
      formData.append("username", userStats.manual.trim());
    } else if (userStats.file) {
      formData.append("username", userStats.file);
    }

    // Handle Password
    if (passStats.type === "manual") {
      formData.append("password", passStats.manual.trim());
    } else if (passStats.file) {
      formData.append("password", passStats.file);
    }

    // Call API
    const response = await axios_instance.post(
      "/api/v1/view/password-detection",
      formData,
      { headers: { "Content-Type": "multipart/form-data" } },
    );

    toast.success("Đã gửi lệnh dò pass xuống Agent!");
    emit("scanned", response.data);
    emit("update:open", false);

    // Reset fields
    ipInput.value = "";
    scanOption.value = "single";
    userStats.manual = "";
    passStats.manual = "";
    // Note: file inputs can't be cleared programmatically easily without ref reference manipulation, ok for now.
  } catch (error) {
    console.error(error);
    toast.error("Gửi lệnh thất bại!");
  }
};
</script>
